import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthCoreService, RoleViewModel } from 'src/proxy';


@Injectable()
export class RoleStoreService {

    _roles$ = new BehaviorSubject<RoleViewModel[]>(null);

    constructor(private authCoreService: AuthCoreService) {
    }

    loadRoles() {
        return this.authCoreService.getRoles();
    }

    get roles() {
        return this._roles$.value;
    }

    set roles(data: RoleViewModel[]) {
        this._roles$.next(data);
    }

    get roles$() {
        return this._roles$;
    }
}
